"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = normalize;
// eslint-disable-next-line import/prefer-default-export
function normalize(models) {
    return {
        byId: models.reduce((byId, model) => Object.assign(byId, { [model.id]: model }), {}),
        allIds: models.map(({ id }) => id),
    };
}
